import React, { useState } from 'react';
import '../styles/Sidebar.css';
import { FaHome, FaUserAlt, FaTools, FaProjectDiagram, FaEnvelope, FaMoon, FaSun, FaFilePdf } from 'react-icons/fa';
import { profileData } from '../data/profileData';

function Sidebar({ theme, toggleTheme, activeSection }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => setIsOpen(!isOpen);

  const handleNavClick = () => setIsOpen(false);

  const menuItems = [
    { id: 'home', icon: <FaHome />, label: 'Home' },
    { id: 'about', icon: <FaUserAlt />, label: 'About Me' },
    { id: 'skills', icon: <FaTools />, label: 'TechStack' },
    { id: 'projects', icon: <FaProjectDiagram />, label: 'Projects' },
    { id: 'contact', icon: <FaEnvelope />, label: 'Contact' },
  ];

  return (
    <>
      <button 
        className="hamburger" 
        onClick={toggleSidebar}
        aria-label="Toggle menu"
      >
        ☰
      </button>

      <nav className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-content">
          <ul className="nav-links">
            {menuItems.map((item) => (
              <li key={item.id} className={activeSection === item.id ? 'active' : ''}>
                <a href={`#${item.id}`} onClick={handleNavClick}>
                  {item.icon} <span>{item.label}</span>
                </a>
              </li>
            ))}
          </ul>

          <div className="bottom-controls">
            <button className="control-btn theme-toggle" onClick={toggleTheme}>
              {theme === 'light' ? <FaMoon /> : <FaSun />}
              <span>{theme === 'light' ? 'Dark Mode' : 'Light Mode'}</span>
            </button>
            
            <a 
              href={profileData.info.cvLink} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="control-btn cv-button"
            >
              <FaFilePdf /> <span>CV</span>
            </a>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Sidebar;